/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react';
import { useSelector } from 'react-redux';
import { Navbar } from './Navbar';
import { useNavigate } from 'react-router-dom';
import { About } from './About';
import LazyLoad from 'react-lazy-load';

export const Home = ({categoryText, setCategoryText}) => {

    const data = useSelector((state)=>state.products);
    const {active, products} = data;

    const [myProducts, setMyProducts] = useState([]);

    useEffect(()=>{
        const filteredProducts = products.filter((product)=>product.category===active);
        setMyProducts(filteredProducts);
    },[data])

    const navigate = useNavigate();
    const handleNavigation=(product)=>{
        const myString = product.category;
        const trimmedString = myString.replace(/\s/g, "").toLowerCase();
        navigate(`/${trimmedString}/${product.id}`);
    }

  return (
    <div>
        <About />
        <Navbar setCategoryText={setCategoryText} />
        {myProducts.length>0?(
            <div className='products-section'>
              <h2>Latest Posts</h2>
              {categoryText!==''&&<h3>Checkout the best {categoryText} on Amazon</h3>}
              <div className='products-container'>
                {myProducts.map((product)=>(
                    <div className='product-card' key={product.id}>
                        <div className='product-main-img'>
                            <LazyLoad threshold={0.95} width={`100%`} height={`100%`}>
                                <img src={product.images[0].img} alt="product"/>
                            </LazyLoad>
                        </div>
                        <p>{product.blog.title}</p>
                        <button onClick={()=>handleNavigation(product)}>Learn More</button>
                    </div>
                ))}
              </div>
            </div>
        ):(
            <div className='products-section'>No products to show</div>
        )}
    </div>
  )
}
